import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=6db31638&"
import script from "./SortDropdown.vue?vue&type=script&lang=js&"
export * from "./SortDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports